module.exports = __webpack_public_path__ + "img/1493279078.c7dea0d8.jpg";